import { useJavascriptRequestDataModelQuery } from 'autogen/swagger/all/hooks';
import { type ReactNode, useCallback } from 'react';
import { ThemeProvider as StyledComponentThemeProvider } from 'styled-components';
import type * as defaultTheme from 'autogen/theming/types/base/default';
import type { Theme } from 'autogen/theming/types/themeTypes';
import themeMap from 'autogen/theming/themeMap';

type DefaultTheme = typeof defaultTheme;
type ThemeFn = (outerTheme?: DefaultTheme | undefined) => DefaultTheme;

export default function ThemeProvider({
    theme = 'default',
    children
}: { theme: ThemeFn | Theme; children: ReactNode }) {
    const { data } = useJavascriptRequestDataModelQuery({ enabled: false });
    const tenant = data?.segmentation.tenant || 'Matas';
    const themeVars = themeMap[tenant.toLocaleLowerCase()][theme];
    const mergeWithOuterTheme = useCallback((outerTheme) => ({ ...outerTheme, ...themeVars }), [theme, tenant]);
    const themeFunc = typeof theme === 'function' ? theme : mergeWithOuterTheme;

    return <StyledComponentThemeProvider theme={themeFunc}>{children}</StyledComponentThemeProvider>;
}
